<template>
  <div>

    <a-modal v-model="visible" title="Transfer Certificate" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleDownload">Download</a-button>
      </template>

      <a-form :form="form">
        <div class="row">
          <!-- Dynamically Generated Fields -->
          <div class="col-md-12 mb-2" v-for="(field, index) in dynamicFields" :key="index">
            <a-form-item :label="formatLabel(field)">
              <a-input
                :placeholder="`Enter ${formatLabel(field)}`"
                v-decorator="[field, { rules: [{ required: false, message: `Please input ${field}!` }] }]"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>

    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Generate Certificates</h5>
        </div>
<!--        <div class="col-6 col-sm-4 text-right">
          <leave-request-form v-if="pagepermission.insertable" @saved="handleCreated"/>
        </div>-->
      </div>
    </div>

    <div class="row align-items-center mb-2" v-if="pagepermission.viewable">
      <div class="col-md-12">
      <a-form :form="form">
        <!-- Single/Bulk Select -->

        <div class="row">
          <div class="col-md-2 col-12 mb-2">
            <a-form-item label="Single or Bulk">
            <a-select
              size="large"
              style="width:100%"
              placeholder="Select Single / Bulk"
              v-decorator="[
                    'single_or_bulk',
                    {
                      rules: [{required: true,message: 'Please select a certificate!!',},],
                    },
                  ]"
              @change="onSingleBulkChange"
              @select="onSingleBulkChange"
            >
              <a-select-option value="Single">Single</a-select-option>
              <a-select-option value="Bulk">Bulk</a-select-option>
            </a-select>
            </a-form-item>
          </div>
        <!-- Session Select -->
        <div class="col-md-2 col-12 mb-2">
          <a-form-item label="Session">
            <a-select
              size="large"
              v-decorator="[
                    'session_id',
                    {
                      rules: [{required: true,message: 'Please select a session!!',},],
                    },
                  ]"
              placeholder="Select Session"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-4 col-12 mb-2" v-if="singleOrBulk === 'Single'">
          <a-form-item label="Select Student">
            <a-select
              show-search
              size="large"
              v-decorator="[
                    'student_id',
                    {
                      rules: [{required: true,message: 'Please select a student!!',},],
                    },
                  ]"
              placeholder="Search student.."
              optionFilterProp="children"
              style="width: 100%"
              @search="searchStudents"
              :filterOption="true"
              :defaultValue="undefined"
            >
              <template v-for="student in students">
                <a-select-option :value="student.id" :key="student.id">
                  {{student.first_name + ' ' + student.last_name + '(' + student.student_code + ')'}}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-md-4 col-12 mb-2">
          <a-form-item label="Select Certificate">
            <a-spin :spinning="certificateTemplateSpinning">
              <a-select
                size="large"
                v-decorator="[
                    'certificate_template_id',
                    {
                      rules: [{required: true,message: 'Please select a certificate!!',},],
                    },
                  ]"
                placeholder="Select certificate"
                optionFilterProp="children"
                style="width: 100%"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">Select Certificate</a-select-option>
                <template v-for="certificateTemplate in certificateTemplates">
                  <a-select-option :value="certificateTemplate.id" :key="certificateTemplate.id">
                    {{certificateTemplate.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </a-form-item>
        </div>
        <!-- Class Select -->
        <div class="col-md-2 col-12 mb-2" v-if="singleOrBulk === 'Bulk'" >
          <a-form-item label="Select Class">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-decorator="[
                    'class_id',
                    {
                      rules: [{required: true,message: 'Please select a Class!!',},],
                    },
                  ]"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </a-form-item>
        </div>
        <!-- Section Select -->
        <div class="col-md-2 col-12 mb-2" v-if="singleOrBulk === 'Bulk'">
          <a-form-item label="Select Section">
            <a-spin :spinning="sectionSpinning">
              <a-select
                size="large"
                v-decorator="[
                      'section_id',
                    ]"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </a-form-item>
        </div>
        </div>
      </a-form>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 d-flex justify-content-end">
        <div class="ml-2 mb-2" v-if="singleOrBulk === 'Single' && pagepermission.viewable" >
          <a-button
            icon="download"
            key="submit"
            type="primary"
            @click="handleCheckProperty"
          >Download</a-button
          >
        </div>
        <div class="ml-2 mb-2" v-if="singleOrBulk === 'Bulk'">
          <a-button
            key="submit"
            type="primary"
            @click="handleGenerate"
          >Generate</a-button
          >
        </div>
        <div class="ml-2 mb-2">
          <button
            v-if="pagepermission.viewable"
            type="button"
            class="btn btn-primary btn-with-addon"
            @click="handleRefresh"
          >
        <span class="btn-addon">
          <i class="btn-addon-icon fe fe-refresh-cw" />
        </span>
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <certificate-export-file-table :data="data" :loading="loading" @handleCertificateUpdateExportFileTable="handleCertificateUpdateExportFileTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import { statuses } from '@/components/leaverequest/data'

import CertificateExportFileTable from '@/components/certificate/Table/index'

export default {
  components: {
    /* LeaveRequestTable,
    LeaveRequestForm, */
    CertificateExportFileTable,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('certificate', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
    this.getExportFiles()
    this.getCertificateTemplates()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      statuses,
      loading: false,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedStudent: undefined,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedStatus: undefined,
      selectedCertificateTemplate: undefined,
      sectionSpinning: false,
      classSpinning: false,
      studentSpinning: false,
      current: 1,
      pageSize: 10,
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      students: null,
      singleOrBulk: 'Single',
      studentSearch: null,
      certificateSingleDefault: 'Single',
      hideStudentSearch: true,
      hideSection: true,
      hideClass: true,
      certificateTemplates: [],
      certificateTemplateSpinning: false,
      dynamicFields: [], // To store dynamic fields for certificate properties
    }
  },
  methods: {
    showModal() {
      this.visible = true
      // this.calendarEventDate = moment(eventDate)
    },
    handleCancel(e) {
      // this.form.resetFields()
      this.dynamicFields = [] // Reset dynamic fields
      this.visible = false
    },
    formatLabel(field) {
      return field.replace(/([A-Z])/g, ' $1').trim() // Insert space before capital letters
    },
    getExportFiles: function() {
      this.loading = true
      this.$http.get('/api/export/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
          category: 'Certificate',
        },
      }).then(({ data }) => {
        console.log(data.data)
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleRefresh() {
      this.getExportFiles()
    },
    handleCreated: function() {
      this.getExportFiles()
    },
    handleCertificateUpdateExportFileTable: function() {
      this.getExportFiles()
    },
    getCertificateTemplates() {
      this.certificateTemplateSpinning = true
      this.$http.get('/api/certificate/templates')
        .then(({ data }) => {
          this.certificateTemplates = data.data
          this.certificateTemplateSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.selectedClass = value
        this.getClassSections(value)
      }
      this.getExportFiles()
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getExportFiles()
      } else {
        this.selectedSection = undefined
        this.getExportFiles()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getExportFiles()
    },
    getStudents: function(isSearch) {
      this.studentSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/student', {
        params: {
          limit: 10,
          search: this.studentSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.students = data.data
      })
    },
    searchStudents: function(value) {
      if (value) {
        this.studentSearch = value
        this.getStudents(true)
      }
    },
    onSingleBulkChange(value) {
      if (value === 'Single') {
        this.singleOrBulk = 'Single'
      } else {
        this.singleOrBulk = 'Bulk'
      }
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getExportFiles()
    },
    onChange(current) {
      this.current = current
      this.getExportFiles()
    },
    handleGenerate() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to generate certificates!`,
            onOk: () => {
              this.$http.get('/api/certificate/bulk', {
                params: {
                  session_id: values.session_id,
                  class_id: values.class_id,
                  section_id: values.section_id,
                  template_id: values.certificate_template_id,
                },
              }).then(({ data }) => {
                this.loading = false
                this.$notification['info']({
                  message: 'Certificate generation started!',
                  description: `Please check status in the section`,
                  duration: 0,
                })
              })
            },
          })
        }
        this.loading = false
      })
    },
    handleCheckProperty() {
      // Check if certificate property are defined in neo_properties table. If yes, show the modal form so that user can enter the dynamic properties of the certificate.
      this.dynamicFields = [] // Reset dynamic fields
      this.$http
        .get('/api/certificate/properties', {
          params: {
            template_id: this.form.getFieldValue('certificate_template_id'),
          },
        })
        .then(({ data }) => {
          if (data.data.length > 0) {
            // console.log('Properties found for the certificate template')
            this.dynamicFields = data.data // Store API response as field names
            this.visible = true // Show the modal form
          } else {
            // console.log('No properties found for the certificate template')
            this.handleDownload()
          }
        })
    },
    handleDownload() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to Download the certificate!`,
            onOk: () => {
              this.visible = false
              // Define known static fields
              const staticFields = ['session_id', 'student_id', 'certificate_template_id']

              // Extract dynamic fields (unknown ones)
              const dynamicFields = {}
              Object.keys(values).forEach((key) => {
                if (!staticFields.includes(key) && values[key]) {
                  dynamicFields[key] = values[key] // Add only if it has a value
                }
              })
              this.$http.get('/api/certificate/single',
                {
                  params: {
                    session_id: values.session_id,
                    student_id: values.student_id,
                    template_id: values.certificate_template_id,
                    ...dynamicFields, // Merge dynamic fields dynamically
                  },
                  responseType: 'blob' },)
                .then((response) => {
                  console.log(response)
                  // Create a Blob from the response data and create a download link.
                  const blob = new Blob([response.data], { type: 'application/pdf' })
                  const url = window.URL.createObjectURL(blob)
                  const a = document.createElement('a')
                  a.href = url
                  a.download = 'characterCertificate' + values['student_id'] + '.pdf' // Specify the file name here
                  a.click()
                  // window.URL.revokeObjectURL(url)
                  /* const pdfWindow = window.open(url, '_blank')
                  pdfWindow.print() */

                  const pdfWindowPopUp = window.open(url, 'PDF_Popup', 'width=1000,height=800')
                  if (!pdfWindowPopUp) {
                    alert('Please enable pop-ups for this website to open the PDF in a pop-up window.')
                  }
                  // pdfWindowPopUp.print()
                  window.URL.revokeObjectURL(url)
                })
                .catch(error => {
                  const reader = new FileReader()
                  reader.onload = () => {
                    try {
                      const errorText = reader.result // This is the text content of the error blob
                      const errorJson = JSON.parse(errorText) // Assuming the error blob is JSON
                      console.error('Error details:', errorJson)
                      // alert('Error: ' + errorJson.message) // Display the error message to the user
                      this.$error({
                        title: 'Error',
                        content: errorJson.message,
                      })
                    } catch (e) {
                      // Handle cases where the error blob is not JSON
                      console.error('Error parsing blob:', reader.result)
                      // alert('An error occurred: ' + reader.result)
                      this.$error({
                        title: 'Error',
                        content: reader.result,
                      })
                    }
                  }
                  reader.readAsText(error)
                })
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>
<style>
  .error { padding: 25px 5px; }
</style>
